function Check()
{if(navigator.appName=="Microsoft Internet Explorer"&&parseInt(navigator.appVersion)>=4)
{IE=true;}
else
{IE=false;}
return IE}
function onCopy()
{document.selection.empty()}
function layer(act,id)
{if(act=='show')
{id.style.visibility='visible'
id.style.display='block'}
else if(act=='hide')
{id.style.visibility='hidden'
id.style.display='none'}}
function news(act,id,idfull,idarrow)
{ind=idfull.id.substr(idfull.id.indexOf('_')+1)
if(act=='show')
{if(id)
{id.style.visibility='hidden'
id.style.display='none'}
idfull.style.visibility='visible'
idfull.style.display='block'
if(id)
{idarrow.innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'hide\',news_'+ind+',newsfull_'+ind+',arrow'+ind+');return false">&lt;&lt;&lt;</a></small>'}
else
{idarrow.innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'hide\',0,newsfull_'+ind+',arrow'+ind+');return false">&lt;&lt;&lt;</a></small>'}
for(x in document.all)
{if(document.all[x].id&&document.all[x].id.indexOf('newsfull')!=-1&&document.all[x]!=idfull)
{var ind=document.all[x].id.substr(document.all[x].id.indexOf('_')+1)
document.all[x].style.visibility="hidden"
document.all[x].style.display="none"
var ind=document.all[x].id.substr(document.all[x].id.indexOf('_')+1)
if(id)
{document.all['arrow'+ind].innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'show\',news_'+ind+',newsfull_'+ind+',arrow'+ind+');return false">&gt;&gt;&gt;</a></small>'}
else
{document.all['arrow'+ind].innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'show\',0,newsfull_'+ind+',arrow'+ind+');return false">&gt;&gt;&gt;</a></small>'}}}}
else if(act=='hide')
{if(id)
{id.style.visibility='visible'
id.style.display='block'}
idfull.style.visibility='hidden'
idfull.style.display='none'
if(id)
{idarrow.innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'show\',news_'+ind+',newsfull_'+ind+',arrow'+ind+');return false">&gt;&gt;&gt;</a></small>'}
else
{idarrow.innerHTML='&nbsp;<small><a href="showtext/?from=news&id='+ind+'" onClick="news(\'show\',0,newsfull_'+ind+',arrow'+ind+');return false">&gt;&gt;&gt;</a></small>'}}}
function init()
{}
function open_new(FileName,Width,Height,Top,Left,NoRes,NoScr)
{var str=""
if(Width>0)
{str="width="+Width}
if(Height>0)
{str+=str.length>0?",height="+Height:"height="+Height}
if(Top>0)
{str+=str.length>0?",top="+Top:"top="+Top}
if(Left>0)
{str+=str.length>0?",left="+Left:"left="+Left}
if(str.length<=0)
{str="width="+screen.width-30+",height="+screen.height-30}
if(NoRes>0)
{str+=str.length>0?",resizable=0":"resizable=0"}
else{str+=str.length>0?",resizable=1":"resizable=1"}
if(NoScr>0)
{str+=str.length>0?",scrollbars=0":"scrollbars=0"}
else
{str+=str.length>0?",scrollbars=1":"scrollbars=1"}
s_win=window.open(FileName,"s_win",str)
s_win.focus()}